'use client';

import React from 'react';
import Link, { type LinkProps } from 'next/link';
import { useIsMobile } from '@/hooks/useDeviceType';

type AnchorProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  // Avoid conflicts with Next.js Link props
  'href' | 'children'
>;

type ResponsiveLinkProps = LinkProps &
  AnchorProps & {
    children: React.ReactNode;
    className?: string;
    /**
     * Default behavior:
     * - desktop/tablet: open in new tab
     * - mobile: open in same tab
     */
    openInNewTabOnDesktop?: boolean;
  };

export function ResponsiveLink({
  children,
  openInNewTabOnDesktop = true,
  rel,
  ...props
}: ResponsiveLinkProps) {
  const isMobile = useIsMobile();
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => setHasMounted(true), []);

  const shouldOpenInNewTab = openInNewTabOnDesktop && hasMounted && !isMobile;

  return (
    <Link
      {...props}
      {...(shouldOpenInNewTab ? { target: '_blank' } : {})}
      {...(rel ? { rel } : shouldOpenInNewTab ? { rel: 'noopener noreferrer' } : {})}
    >
      {children}
    </Link>
  );
}
